import { z } from 'zod';

export const diagnosisSchema = z.object({
  id: z.string(),
  description: z.string(),
  icd9: z.string(),
});
